module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_feeling02_gray-27eac7bfbda258c568e0a85ee02d1443.svg";